var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 47.7051,
    x2: 24.0398,
    y1: 45.6842,
    y2: 45.5954,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5607,
    x2: 24.5607,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.4723,
    x2: 26.4723,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.4129,
    x2: 28.4129,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3245,
    x2: 30.3245,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2527,
    x2: 32.2527,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1643,
    x2: 34.1643,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.1049,
    x2: 36.1049,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.0165,
    x2: 38.0165,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.9323,
    x2: 39.9323,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.8439,
    x2: 41.8439,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.8134,
    x2: 43.8134,
    y1: 45.8654,
    y2: 49.1684,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.7003,
    x2: 45.7003,
    y1: 42.0256,
    y2: 45.3286,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.9177,45.3276 c0.8493-0.3076,1.8373-0.121,2.5182,0.56l4.8606,4.8606c0.938,0.938,0.938,2.4589,0,3.397l-1.9462,1.9462 c-0.9381,0.9381-2.459,0.9381-3.397,0l-4.8606-4.8606c-0.6461-0.6461-0.8472-1.5687-0.6033-2.3869"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.4811,44.2366C58.4623,41.6794,59,38.9025,59,36c0-12.7031-10.2979-23-23-23c-12.7023-0.0001-23,10.2969-23,23 c0,12.7022,10.2978,23,23,23c4.0701,0,7.8933-1.0574,11.21-2.9123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,31c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,28,30,29.3448,30,31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,31c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,29.3448,48,31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsure);
export default __webpack_public_path__ + "static/media/Unsure.3cbcf9f7b2bda9ebd7a091a58d242d2d.svg";
export { ForwardRef as ReactComponent };